// extracted by css-extract-rspack-plugin
export default {"back-button":"back-button___uG2dzcvb"};